import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import MenuAppBar from '../menuAppBar/MenuAppBar';
import SidebarDrawer from '../sidebarDrawer/SidebarDrawer';
import { mainLayoutStyles } from './mainLayoutStyles';
import { ModuleDrawerProvider } from '../../../providers/ModuleDrawerProvider';
import ModuleDrawer from '../../common/drawers/ModuleDrawer/ModuleDrawer';
import { useGetCurrentUser } from '../../../services/react-query/users/useGetCurrentUser';
import { Loading } from '../../../uikit';
import { FilterDisplayProvider } from '../../../contexts/FilterDisplayProvider';

const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(!isMobile);

  const { data: user } = useGetCurrentUser();
  if (!user)
    return (
      <Box sx={{ height: '100dvh', width: '100dvw', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loading />
      </Box>
    );

  return (
    <FilterDisplayProvider>
      <ModuleDrawerProvider>
        <title>ScheduLink</title>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
          <MenuAppBar setSidebarOpen={setSidebarOpen} />
          {/* <Box sx={(t) => t.mixins.toolbar} /> */}
          <SidebarDrawer sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <Box sx={mainLayoutStyles} component="main">
            <Outlet />
          </Box>
          <ModuleDrawer />
        </Box>
      </ModuleDrawerProvider>
    </FilterDisplayProvider>
  );
};

export default MainLayout;
